import { mapState } from 'vuex'

const tableMixin = {
  data () {
    return {
      tableSize1: '',
      lastName: ''
    }
  },
  computed: {
    ...mapState({
      tableBordered: state => state.app.tableBordered
    }),
    tableSize: {
      get () { return this.tableSize1 || this.$store.state.app.tableSize },
      set (value) {
        this.tableSize1 = value
      }
    }
  },
  methods: {
    /**
     * 通用的分页大小改变处理方法
     * 当改变每页显示数量时，自动跳转到第一页
     * @param {Number} current - 当前页码
     * @param {Number} pageSize - 新的每页显示数量
     */
    onShowSizeChange (current, pageSize) {
      if (this.queryParam) {
        this.queryParam.pageSize = pageSize
        // 改变每页显示数量时，总是跳转到第一页
        this.queryParam.pageNum = 1
        // 如果组件有 getList 方法，调用它刷新数据
        if (typeof this.getList === 'function') {
          this.getList()
        }
      }
    }
  }
}

export {
  tableMixin
}
